import React, { Component } from 'react'
import PropTypes from 'prop-types'
import getBasketDetail from "../actions/getBasketDetail"
import BasketDetail from "../../merger-v2/components/BasketDetail"
import classNames from 'classnames'
import { notification } from 'antd'
import _ from 'lodash'

class BasketDetailPage extends Component {
    constructor(props) {
        super(props);
        this.notifRootRef = React.createRef();
    }
    state = {
        loading: false,
        error: '',
        basket: null,
    }


    componentDidMount() {
        this._fetchBasket()
    }

    _fetchBasket = async () => {
        notification.destroy()
        if (this.state.loading) return false

        this.setState({
            loading: true,
            error: ''
        })

        try {
            const basket = await getBasketDetail(this.props.id)

            this.setState({
                loading: false,
                error: '',
                basket,
            })
            const { packed_methods = [], items = [] } = basket || {}
            const listItemNormal = items.filter(item => !["THANK_CARD", "BRAND_KIT"].includes(item.product_type)) || []
            const listItemSpecial = items.filter(item => ["THANK_CARD", "BRAND_KIT"].includes(item.product_type)) || []
            const isUnShowNotification = !!listItemNormal.length && listItemNormal.every(i => _.get(i, 'meta.product.meta.packed_method', '') === _.get(listItemNormal[0], 'meta.product.meta.packed_method')) && 
            !!listItemSpecial.length 
            const isShowNotification = packed_methods.length > 1 && !isUnShowNotification
            isShowNotification && notification.open({
                message: <div className='d-flex align-items-center'>
                    <i className="fa fa-exclamation-circle text-warning mr-4" aria-hidden="true" style={{ fontSize: 70 }} />
                    <span className='font-weight-bold'>{`Trong giỏ có 2 kiểu đóng gói khác nhau, cần lưu ý gộp đủ item trong đơn.`}</span>
                </div>,
                placement: 'topRight',
                icon: null,
                duration: 0,
                style: { borderRadius: 20, maxHeight: 'unset', overflowY: 'unset' },
                getContainer: () => this.notifRootRef.current,
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    _handleClose = () => {

    }

    render() {
        const { loading, basket, error } = this.state

        return (
            <div className={classNames("BasketDetailPage", { loading })}>
                <div id="notif-top-center-root" ref={this.notifRootRef} />
                {
                    !!error &&
                    <div className="alert alert-danger">
                        <div className="Huge">
                            <strong>Lỗi: </strong>
                            <span>{error}</span>
                        </div>
                    </div>
                }
                {
                    !!basket &&
                    <BasketDetail result={basket} onClose={this._fetchBasket} disabledCheckExists reload={this._fetchBasket} containerRef={this.notifRootRef} />
                }
            </div>
        )
    }
}

BasketDetailPage.propTypes = {
    id: PropTypes.string.isRequired,
}

export default BasketDetailPage
